import {UcoastEl} from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class PdpFloatingContaminants extends UcoastEl {
  static htmlSelector = 'pdp-floating-contaminants'

  issues: HTMLElement
  show: HTMLElement
  hide: HTMLElement

  constructor() {
    super()

    this.issues = q.rs('[data-uc-pdp-floating-contaminants-issues]', this)
    this.show = q.rs('[data-uc-pdp-floating-contaminants-issues-show]', this)
    this.hide = q.rs('[data-uc-pdp-floating-contaminants-issues-hide]', this)

    this.show.addEventListener('click', this.fadeIn.bind(this))
    this.hide.addEventListener('click', this.fadeOut.bind(this))
  }

  fadeIn() {
    this.show.classList.add('active')
    this.hide.classList.remove('active')
    this.issues.classList.toggle('animate')
  }

  fadeOut() {
    this.show.classList.remove('active')
    this.hide.classList.add('active')
    this.issues.classList.toggle('animate')
  }
}
